import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-[1_53%_1_1] w-full gap-12 flex-row items-center p-4 shadow-md rounded border-l-4 border-h-primary-500" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "flex-[53%] text-h-neutral-900" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("img", {
      src: _ctx.course.file?.url,
      alt: _ctx.course.name,
      class: "w-[123px] min-w-[123px] h-[73px] object-cover rounded",
      onEmptied: _cache[0] || (_cache[0] = ($event: any) => ('@/assets/images/image-default.svg'))
    }, null, 40, _hoisted_2),
    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.course.name), 1),
    _createElementVNode("p", {
      class: _normalizeClass(["rounded-2xl text-center py-[2.5px] w-[78px] px-2 text-xs", [
        { 'text-white bg-h-primary-500': !_ctx.course.adaptive },
        { ' text-h-neutral-50 bg-h-secondary-600': _ctx.course.adaptive },
      ]])
    }, _toDisplayString(_ctx.labelCourseType), 3),
    _createVNode(_component_Button, {
      class: "btn-simple gap-2 flex-1 min-w-[183px]",
      onClick: _ctx.redirectToForum
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t("labels.generic", { pt: "Acessar fórum", en: "Access forum" })), 1),
        _createVNode(_component_v_icon, {
          name: "co-arrow-right",
          width: "24",
          height: "24"
        })
      ]),
      _: 1
    }, 8, ["onClick"])
  ]))
}